module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "auth-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.wantsToSignUp ? _vm.signUpWithPassword() : _vm.loginWithPassword()
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.wantsToSignUp ? 'Sign up' : 'Sign in'))]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wantsToSignUp),
      expression: "wantsToSignUp"
    }]
  }, [_c('label', {
    attrs: {
      "for": "confirm-password"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "type": "password",
      "name": "confirm-password",
      "id": "confirm-password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.wantsToSignUp),
      expression: "!wantsToSignUp"
    }],
    staticClass: "clearfix btn-group"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.wantsToSignUp = true
      }
    }
  }, [_vm._v("Sign up")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wantsToSignUp),
      expression: "wantsToSignUp"
    }]
  }, [_c('button', {
    staticClass: "signup-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign up")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "social-providers"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signInWithProvider('twitter')
      }
    }
  }, [_vm._v("twitter")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5c5fee90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Auth.vue
// module id = 200
// module chunks = 1